import { render, staticRenderFns } from "./CredentialsIndex.vue?vue&type=template&id=465d2052"
import script from "./CredentialsIndex.vue?vue&type=script&lang=js"
export * from "./CredentialsIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports